import { useIsMobile } from "../../hooks/useIsMobile";

const PanelFooter = ({
  children,
}: {
  children: React.ReactElement | React.ReactElement[];
}) => {
  const isMobile = useIsMobile(768);

  return (
    <div
      style={{
        padding: 20,
        backgroundColor: "#f5f5f5",
        borderBottomLeftRadius: isMobile ? 0 : 20,
        borderBottomRightRadius: isMobile ? 0 : 20,
      }}
    >
      {children}
    </div>
  );
};

export default PanelFooter;
